module.exports = __webpack_public_path__ + "media/images/diversity-hero-3-edd747b92cd8aed0642aa6cea71c3317.png";